import React, { useState, useEffect } from 'react';
import { Box, Grid, Card, CardContent, Typography, CircularProgress, Alert } from '@mui/material';
import RobotIcon from '@mui/icons-material/Adb';

// Import all avatar images
import face1 from '../../assets/avatars/Face-1.png';
import face2 from '../../assets/avatars/Face-2.png';
import face from '../../assets/avatars/Face.png';
import faceCo1 from '../../assets/avatars/face_co (1) 4.png';
import faceCo12 from '../../assets/avatars/face_co (12) 4.png';
import faceCo13 from '../../assets/avatars/face_co (13) 4.png';
import faceCo14 from '../../assets/avatars/face_co (14) 4.png';
import faceCo15 from '../../assets/avatars/face_co (15) 4.png';
import faceCo16 from '../../assets/avatars/face_co (16) 4.png';
import faceCo17 from '../../assets/avatars/face_co (17) 4.png';
import faceCo18 from '../../assets/avatars/face_co (18) 4.png';
import faceCo19 from '../../assets/avatars/face_co (19) 4.png';
import faceCo2 from '../../assets/avatars/face_co (2) 4.png';
import faceCo20 from '../../assets/avatars/face_co (20) 4.png';
import faceCo21 from '../../assets/avatars/face_co (21) 4.png';
import faceCo23 from '../../assets/avatars/face_co (23) 4.png';
import faceCo24 from '../../assets/avatars/face_co (24) 4.png';
import faceCo25 from '../../assets/avatars/face_co (25) 4.png';
import faceCo26 from '../../assets/avatars/face_co (26) 4.png';
import faceCo27 from '../../assets/avatars/face_co (27) 5.png';
import faceCo28 from '../../assets/avatars/face_co (28) 4.png';
import faceCo29 from '../../assets/avatars/face_co (29) 4.png';
import faceCo3 from '../../assets/avatars/face_co (3) 4.png';
import faceCo30 from '../../assets/avatars/face_co (30) 5.png';
import faceCo31 from '../../assets/avatars/face_co (31) 4.png';
import faceCo32 from '../../assets/avatars/face_co (32) 4.png';
import faceCo33 from '../../assets/avatars/face_co (33) 4.png';
import faceCo34 from '../../assets/avatars/face_co (34) 4.png';
import faceCo35 from '../../assets/avatars/face_co (35) 4.png';
import faceCo36 from '../../assets/avatars/face_co (36) 4.png';
import faceCo37 from '../../assets/avatars/face_co (37) 4.png';
import faceCo38 from '../../assets/avatars/face_co (38) 5.png';
import faceCo39 from '../../assets/avatars/face_co (39) 4.png';
import faceCo4 from '../../assets/avatars/face_co (4) 4.png';
import faceCo40 from '../../assets/avatars/face_co (40) 4.png';
import faceCo41 from '../../assets/avatars/face_co (41) 4.png';
import faceCo42 from '../../assets/avatars/face_co (42) 4.png';
import faceCo43 from '../../assets/avatars/face_co (43) 4.png';
import faceCo44 from '../../assets/avatars/face_co (44) 4.png';
import faceCo45 from '../../assets/avatars/face_co (45) 4.png';
import faceCo46 from '../../assets/avatars/face_co (46) 4.png';
import faceCo47 from '../../assets/avatars/face_co (47) 4.png';
import faceCo48 from '../../assets/avatars/face_co (48) 4.png';
import faceCo49 from '../../assets/avatars/face_co (49) 4.png';
import faceCo5 from '../../assets/avatars/face_co (5) 4.png';
import faceCo51 from '../../assets/avatars/face_co (51) 4.png';
import faceCo6 from '../../assets/avatars/face_co (6) 4.png';
import faceCo7 from '../../assets/avatars/face_co (7) 4.png';
import faceCo8 from '../../assets/avatars/face_co (8) 4.png';
import faceCo from '../../assets/avatars/face_co 4.png';

// We'll display all available avatar images
const ImageAvatarSelector = ({ onSelectAvatar }) => {
  const [avatars, setAvatars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // This function will prepare all available avatar images
    const prepareAvatarImages = () => {
      try {
        setLoading(true);
        setError(null);
        
        // Create an array of all imported avatar images
        const avatarImages = [
          { id: 1, name: 'Avatar 1', photoUrl: face1, type: 'robot' },
          { id: 2, name: 'Avatar 2', photoUrl: face2, type: 'robot' },
          { id: 3, name: 'Avatar 3', photoUrl: face, type: 'robot' },
          { id: 4, name: 'Avatar 4', photoUrl: faceCo1, type: 'robot' },
          { id: 5, name: 'Avatar 5', photoUrl: faceCo12, type: 'robot' },
          { id: 6, name: 'Avatar 6', photoUrl: faceCo13, type: 'robot' },
          { id: 7, name: 'Avatar 7', photoUrl: faceCo14, type: 'robot' },
          { id: 8, name: 'Avatar 8', photoUrl: faceCo15, type: 'robot' },
          { id: 9, name: 'Avatar 9', photoUrl: faceCo16, type: 'robot' },
          { id: 10, name: 'Avatar 10', photoUrl: faceCo17, type: 'robot' },
          { id: 11, name: 'Avatar 11', photoUrl: faceCo18, type: 'robot' },
          { id: 12, name: 'Avatar 12', photoUrl: faceCo19, type: 'robot' },
          { id: 13, name: 'Avatar 13', photoUrl: faceCo2, type: 'robot' },
          { id: 14, name: 'Avatar 14', photoUrl: faceCo20, type: 'robot' },
          { id: 15, name: 'Avatar 15', photoUrl: faceCo21, type: 'robot' },
          { id: 16, name: 'Avatar 16', photoUrl: faceCo23, type: 'robot' },
          { id: 17, name: 'Avatar 17', photoUrl: faceCo24, type: 'robot' },
          { id: 18, name: 'Avatar 18', photoUrl: faceCo25, type: 'robot' },
          { id: 19, name: 'Avatar 19', photoUrl: faceCo26, type: 'robot' },
          { id: 20, name: 'Avatar 20', photoUrl: faceCo27, type: 'robot' },
          { id: 21, name: 'Avatar 21', photoUrl: faceCo28, type: 'robot' },
          { id: 22, name: 'Avatar 22', photoUrl: faceCo29, type: 'robot' },
          { id: 23, name: 'Avatar 23', photoUrl: faceCo3, type: 'robot' },
          { id: 24, name: 'Avatar 24', photoUrl: faceCo30, type: 'robot' },
          { id: 25, name: 'Avatar 25', photoUrl: faceCo31, type: 'robot' },
          { id: 26, name: 'Avatar 26', photoUrl: faceCo32, type: 'robot' },
          { id: 27, name: 'Avatar 27', photoUrl: faceCo33, type: 'robot' },
          { id: 28, name: 'Avatar 28', photoUrl: faceCo34, type: 'robot' },
          { id: 29, name: 'Avatar 29', photoUrl: faceCo35, type: 'robot' },
          { id: 30, name: 'Avatar 30', photoUrl: faceCo36, type: 'robot' },
          { id: 31, name: 'Avatar 31', photoUrl: faceCo37, type: 'robot' },
          { id: 32, name: 'Avatar 32', photoUrl: faceCo38, type: 'robot' },
          { id: 33, name: 'Avatar 33', photoUrl: faceCo39, type: 'robot' },
          { id: 34, name: 'Avatar 34', photoUrl: faceCo4, type: 'robot' },
          { id: 35, name: 'Avatar 35', photoUrl: faceCo40, type: 'robot' },
          { id: 36, name: 'Avatar 36', photoUrl: faceCo41, type: 'robot' },
          { id: 37, name: 'Avatar 37', photoUrl: faceCo42, type: 'robot' },
          { id: 38, name: 'Avatar 38', photoUrl: faceCo43, type: 'robot' },
          { id: 39, name: 'Avatar 39', photoUrl: faceCo44, type: 'robot' },
          { id: 40, name: 'Avatar 40', photoUrl: faceCo45, type: 'robot' },
          { id: 41, name: 'Avatar 41', photoUrl: faceCo46, type: 'robot' },
          { id: 42, name: 'Avatar 42', photoUrl: faceCo47, type: 'robot' },
          { id: 43, name: 'Avatar 43', photoUrl: faceCo48, type: 'robot' },
          { id: 44, name: 'Avatar 44', photoUrl: faceCo49, type: 'robot' },
          { id: 45, name: 'Avatar 45', photoUrl: faceCo5, type: 'robot' },
          { id: 46, name: 'Avatar 46', photoUrl: faceCo51, type: 'robot' },
          { id: 47, name: 'Avatar 47', photoUrl: faceCo6, type: 'robot' },
          { id: 48, name: 'Avatar 48', photoUrl: faceCo7, type: 'robot' },
          { id: 49, name: 'Avatar 49', photoUrl: faceCo8, type: 'robot' },
          { id: 50, name: 'Avatar 50', photoUrl: faceCo, type: 'robot' },
        ];
        
        setAvatars(avatarImages);
      } catch (error) {
        console.error('Error preparing avatar images:', error);
        setError('Failed to load avatar images. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    prepareAvatarImages();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }
  
  if (avatars.length === 0) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        No avatar images found. Please add images to the assets/avatars directory.
      </Alert>
    );
  }

  return (
    <Grid container spacing={2} sx={{ maxHeight: '65vh', overflow: 'auto', px: 2 }}>
      {avatars.map((avatar) => (
        <Grid item xs={3} sm={2} md={2} key={avatar.id}>
          <Card 
            sx={{ 
              cursor: 'pointer',
              transition: 'transform 0.2s',
              bgcolor: 'transparent',
              p: 0.5,
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 3,
                bgcolor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
            onClick={() => onSelectAvatar(avatar)}
            elevation={0}
          >
            <CardContent sx={{ textAlign: 'center', p: 1, '&:last-child': { pb: 1 } }}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                height: 50,
                width: '100%'
              }}>
                <img 
                  src={avatar.photoUrl} 
                  alt={avatar.name}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '100%', 
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    // Replace with fallback icon if image fails to load
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<svg style="width:40px;height:40px;color:#757de8" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></svg>';
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ImageAvatarSelector;